export const requestVerificationToken = document.querySelector('input[name="__RequestVerificationToken"]')?.value;

export function addCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function sanitizeUrl(url) {
    return url.toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
}

export function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}

export let pathAndQuery = location.pathname + location.search + location.hash;

export let returnUrlQueryString = `returnurl=${encodeURIComponent(pathAndQuery)}`;

export const archivedBadge = "<span class=\"badge badge-light-primary\">Archived</span>";

export const slideUp = (el, speed, callback) => {
    KTUtil.slideUp(el, speed ?? 250, callback);
}

export const slideDown = (el, speed, callback) => {
    KTUtil.slideDown(el, speed ?? 250, callback);
}

export const show = (el, display) => {
    if (typeof el !== 'undefined' && el) {
        el.style.display = (display ? display : 'block');
    }
}

export const hide = (el) => {
    if (typeof el !== 'undefined' && el) {
        el.style.display = 'none';
    }
}

export function createUUID() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function currentCulture() {
    return document.getElementById("currentCulture")?.value ?? "en-gb";
}

export function currentCurrency() {
    return document.getElementById("currentCurrency")?.value ?? "£";
}

export function getCurrencySymbol() {
    return (0).toLocaleString(currentCulture(), {
        style: 'currency',
        currency: currentCurrency(),
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();
}

export function formatCurrency(amount) {
    return new Intl.NumberFormat(currentCulture(), {
        style: "currency",
        currency: currentCurrency(),
    }).format(amount);
}
